// removed by extract-text-webpack-plugin
module.exports = {"menuText":"var(--sidebar-menu-text)","menuActiveText":"var(--sidebar-active-text)","subMenuActiveText":"var(sidebar-submenu-text)","menuBg":"var(--sidebar-menu-bg)","menuHover":"var(--sidebar-menu-hover)","subMenuBg":"var(--sidebar-submenu-bg)","subMenuHover":"var(--sidebar-submenu-hover)","sideBarWidth":"var(--sidebar-width)"};


//////////////////
// WEBPACK FOOTER
// ./src/sharedAssets/scss/index.scss
// module id = sOzx
// module chunks = 102